import { useEffect } from "react";
import api from "../../apis/api";
import useContactsPermissions from "./useContactsPermissions";
import ContactsNotEnabled from "./ContactsNotEnabled";
import AddressBook from "./AddressBook";

/**
 * Wrapper that gates the AddressBook behind the contacts feature flag.
 * When the feature is disabled, ContactsNotEnabled is rendered instead,
 * ensuring AddressBook never mounts and its API hooks never fire.
 *
 * Refreshes the domain configuration on mount so admin-portal toggles of
 * `contactmanagement` are picked up on page reload even when the disabled
 * state view (which itself fires no API calls) is shown.
 */
const ContactsPage = () => {
  const { isContactsEnabled } = useContactsPermissions();

  useEffect(() => {
    api.refreshDomainConfiguration();
  }, []);

  return isContactsEnabled ? <AddressBook /> : <ContactsNotEnabled />;
};

export default ContactsPage;
